import React, { useEffect, useState } from "react";
import BounceLoader from "react-spinners/ClipLoader";
import { ERROR_ROUTE, START_ROUTE } from "../constants/routes.constants";
import RespondentFlowApi from "../services/respondentFlow.api";
import Error from "./Error";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LoaderComponent from "../components/LoaderComponent";
import FormSkeleton from "../components/question-components/form-skeleton";
import SurveyStatusPage from "../components/question-components/survey-status";
import LoggerService from "../services/logger.service";
import { LOG_EVENTS } from "../constants/logs.constants";
import { SessionUtils } from "../utils/session.utils";
import { useRespondentContext } from "../contexts/respondent.context";

const RedirectPage = () => {
  const [paramActive, setParamActive] = useState(false);
  const [params, setParams] = useState({});
  const { status } = useParams(); // Get the status from the URL path
  const location = useLocation();
  const [Loader] = useState(true);
  let navigate = useNavigate();
  const [ErrorMessage, setErrorMessage] = useState("Loading");
  const { journeyToken } = useRespondentContext();

  const mapStatusToNumber = (statusString) => {
    const statusMap = {
      complete: 1,
      terminate: 2,
      quotafull: 3,
      security: 4,
      // Add more mappings as needed
    };

    return statusMap[statusString.toLowerCase()] || 0; // Default to 0 or another value if not found
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const newParams = {};

    searchParams.forEach((value, key) => {
      newParams[key] = value;
    });

    // Convert string status to number and map it to estatus
    newParams.vq_sid = mapStatusToNumber(status);

    // Map token parameter to etoken if needed
    if (newParams.transactionId) {
      newParams.vq_tid = newParams.transactionId;
    }

    setParams(newParams);
  }, [location.search, status]);

  // Trigger the API call when params are updated
  useEffect(() => {
    if (Object.keys(params).length > 0) {
      if (paramActive === false) setParamActive(true);
    }
  }, [params]);

  useEffect(() => {
    if (paramActive === true) {
      try {
        params["url"] = window.location.href;
        LoggerService.logEvent(LOG_EVENTS.ENDING_RECEIVED);
        RespondentFlowApi.post("/v1/ending", params)
          .then(async (data) => {
            if (data.result === "not_ok") {
              LoggerService.logEvent(LOG_EVENTS.ENDING_ERROR, "Ending returned not_ok");
              navigate(`${ERROR_ROUTE}?token=${params.token}`);
              return;
            } else if (data.hasError) {
              LoggerService.logEvent(LOG_EVENTS.ENDING_ERROR, data.messages?.[0]);
              setErrorMessage(data.messages[0]);
              return;
            } else {
              if (data.isInternalRedirect) {
                let obj = {};
                obj.traceId = data.traceId;
                obj.paramList = data.paramList;
                obj.sessionUid = data.sessionUid;
                obj.surveyUid = data.surveyUid;
                obj.vendorUid = data.vendorUid;
                obj.vendorToken = data.vendorToken ?? "";
                obj.token = data.token;
                obj.tokenId = data.tokenId;
                obj.userUid = data.userUid;
                obj.userId = data.userId;
                obj.isEnding = true;

                await LoggerService.logEvent(LOG_EVENTS.ENDING_REDIRECT_TO_START);

                // sessionStorage.clear() wipes the journey/respondent tokens too -
                // the journey continues (re-routing), it isn't ending here, so
                // restore them rather than letting a fresh one get minted.
                sessionStorage.clear();
                SessionUtils.setJourneyToken(journeyToken);
                if (obj.token) SessionUtils.setRespondentToken(obj.token);
                sessionStorage.setItem("params", JSON.stringify(obj));

                navigate(`${START_ROUTE}?token=${obj.token}`);
              } else {
                await LoggerService.logEvent(LOG_EVENTS.ENDING_REDIRECT_TO_SUPPLIER);
                await LoggerService.logEvent(LOG_EVENTS.JOURNEY_END, "Redirected to supplier from ending");
                sessionStorage.clear();
                window.location.href = `${data.redirectUrl}`;
              }
            }
          })
          .catch((e) => {
            console.error(e);
            LoggerService.logEvent(LOG_EVENTS.ENDING_ERROR, "Error calling ending: " + (e?.message || String(e)));
            navigate(ERROR_ROUTE);
          });
      } catch (err) {
        console.error(err);
        LoggerService.logEvent(LOG_EVENTS.ENDING_ERROR, "Exception in ending: " + (err?.message || String(err)));
        throw err;
      }
    }
    // eslint-disable-next-line
  }, [paramActive]);

  if (ErrorMessage && ErrorMessage !== "Loading") {
    return <SurveyStatusPage status="error" message={ErrorMessage} />;
  }

  return (
    <>
      {/* {Loader ? (
        ErrorMessage === "Loading" ? (
          <FormSkeleton />
        ) : (
          <SurveyStatusPage status="redirect" />
        )
      ) : (
        <>
          <div className="flex  justify-center">
            <img src="https://img.icons8.com/bubbles/256/man-with-a-clock.png" alt="" />
          </div>
        </>
      )} */}
      <FormSkeleton />
    </>
  );
};

export default RedirectPage;
